import {documentComponent} from '@/core/utils/t/document-component'

export const doc = documentComponent({
  name: 'ConfirmEmailForm'
})